// Renewal window for publications. Matches the server-side gate in
// renew_property_publishing — keep these constants in sync with the SQL and
// with mobile/utils/publish-renewal.ts.

export const PUBLISH_RENEWAL_WINDOW_DAYS = 7;

const MS_PER_DAY = 24 * 60 * 60 * 1000;

export function isInPublishRenewalWindow(publishExpiresAt: string | null | undefined): boolean {
  if (!publishExpiresAt) return false;
  const expiry = new Date(publishExpiresAt).getTime();
  if (Number.isNaN(expiry)) return false;
  const msUntilExpiry = expiry - Date.now();
  return msUntilExpiry <= PUBLISH_RENEWAL_WINDOW_DAYS * MS_PER_DAY;
}

// True when the property card should render the "Renovar" CTA instead of
// "Publicada" / "Publicar" / "Ocultar". An expired publication always shows
// Renovar; a still-published one only shows it inside the 7-day window.
export function shouldShowRenovarPublish(property: {
  publish_status?: string | null;
  publish_expires_at?: string | null;
}): boolean {
  if (property.publish_status === 'expired') return true;
  if (property.publish_status === 'published') return isInPublishRenewalWindow(property.publish_expires_at);
  return false;
}
